/**
 * "#1914842" — a link to the ticket in Zendesk when it is a real one, plain
 * text otherwise. Opens in a new tab and never selects the row it sits in.
 */

import { useSession } from '../../auth/session';
import { cn } from '../../lib/cn';
import { zendeskTicketUrl } from '../../lib/ticket/zendesk-link';

export function ZendeskTicketRef({
  externalId,
  className,
}: {
  externalId: string;
  className?: string;
}) {
  const { data: session } = useSession();
  const url = zendeskTicketUrl(session?.zendeskSubdomain, externalId);

  if (!url) return <span className={className}>#{externalId}</span>;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title="Open this ticket in Zendesk"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      // The caller's layout classes first, then the link look — last, so a
      // caller's grey text colour cannot turn it back into plain text.
      className={cn(
        className,
        'text-accent-700 underline underline-offset-2 hover:text-accent-600',
      )}
    >
      #{externalId}
    </a>
  );
}
